import { useTheme } from "@emotion/react";
import React from "react";
const FileIcon = ({ onClick }) => {
    const { color } = useTheme();
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "36px", height: "36px", viewBox: "0 0 24 24", color: color.textMuted, onClick: onClick },
        React.createElement("defs", null,
            React.createElement("style", null, `.a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}`)),
        React.createElement("path", { className: "a", d: "M22.5,21.75a1.5,1.5,0,0,1-1.5,1.5H3a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,3,.75H18.045a1.5,1.5,0,0,1,1.048.426l2.954,2.883A1.5,1.5,0,0,1,22.5,5.133Z" }),
        React.createElement("line", { className: "a", x1: "6.045", y1: "8.25", x2: "18.045", y2: "8.25" }),
        React.createElement("line", { className: "a", x1: "6.045", y1: "12.75", x2: "18.045", y2: "12.75" }),
        React.createElement("line", { className: "a", x1: "6.045", y1: "17.25", x2: "12.045", y2: "17.25" })));
};
export default FileIcon;
//# sourceMappingURL=FileIcon.js.map